export class TargetGoodsInfoModel {

  /**
   * Pコード
   */
  public pCode: string = <string>'';

  /**
   * 商品名
   */
  public goodsName: string = <string>'';

  /**
   * 規格名
   */
  public guideStandardName: string = <string>'';

  /**
   * メーカー名
   */
  public makerName: string = <string>'';

  /**
   * 支払先取引先コード
   */
  public payeeClientCode: string = <string>'';

  /**
   * 取引先名称(漢字)
   */
  public supplierNameKanji: string = <string>'';

  /**
   * 表示用取引先
   */
  public displaySupplier: string = <string>'';

  /**
   * 本登録日時
   */
  public regularRegistDate: string = <string>'';

  /**
   * 関連Pコード(旧)
   */
  public relationPcodeOld: string = <string>'';

  /**
   * 関連Pコード(新)
   */
  public relationPcodeNew: string = <string>'';

  /**
   * グループID
   */
  public groupId: number = <number>-1;

  /**
   * 取扱期間（終了）
   */
  public applyTermEnd: string = <string>'';

}
